'use strict';

var isEqual = require('./isEqual');

function defaultMatcher(f) {
  return function(el) {
    return isEqual(el, f);
  };
}

module.exports = defaultMatcher;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/defaultMatcher.js
// module id = 441
// module chunks = 0